module.exports = function redisCache(redisClient, { prefix = 'cache:', expire = 3600 } = {}) {
    return async (req, res, next) => {
        if (req.method !== 'GET') return next();
        const key = prefix + req.url;
        try {
            const cached = await redisClient.get(key);
            if (cached) {
                res.writeHead(200, { 'Content-Type': 'application/json' });
                return res.end(cached);
            }
            const originalEnd = res.end;
            res.end = function (chunk, encoding, callback) {
                if (res.statusCode === 200 && chunk) {
                    redisClient.set(key, chunk.toString(), { EX: expire }).catch(console.error);
                }
                originalEnd.call(res, chunk, encoding, callback);
            };
            next();
        } catch {
            next();
        }
    };
};
